export const defaultHeaders = [
    {
        name: 'uf',
        text: 'UF',
        order: true,
        position: 0
    },
    {
        name: 'codigo',
        text: 'Código',
        order: true,
        position: 1
    },
    {
        name: 'razaoSocial',
        text: 'Razão Social',
        order: true,
        position: 2
    },
    {
        name: 'cnpj',
        text: 'CNPJ',
        order: true,
        position: 3
    },
    {
        name: 'categorizacao',
        text: 'Categorização',
        order: true,
        position: 4
    },
    {
        name: 'dataInicioVigencia',
        text: 'Data Inicio Vigência',
        order: true,
        position: 5
    },
    {
        name: 'dataFimVigencia',
        text: 'Data Fim Vigência',
        order: true,
        position: 6
    }
]

export const defaultLoaders = [
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    }
]
